<template>
  	<div id="app">
      <div :style="style">
        <!-- <view-header></view-header> -->
        <router-view></router-view>
      </div>
      
  	</div>
</template>

<script>
import viewHeader from './components/header.vue'

export default {
  	name: 'App', 
    components:{
      viewHeader
    }, 
  data(){
    return{
			style:{},
      
    }
   
  },
  created() {
		let _self = this;
		console.log(window.screen.availWidth,'window.innerWidth');
		if (window.screen.availWidth < 1600) {
			let num = window.screen.availWidth / 1600;
			_self.style = {
				width: '1600px',
				position: 'absolute',
				top:'0',
				left:'50%',
				transformOrigin:'top left',
				transform: 'scale(' + num + ') translate(-50%,0)'
			}
		}
	},
  methods: {
    
  },

}
</script>

<style>
body{
  color: #191919;
  background: #F5F7FA;
  margin: 0;
  width: 100%;
	height: auto;
  scroll-behavior: smooth;
	overflow: visible;
  overflow-x:hidden; 

	
  
}
@media screen and (max-width: 1600px) {
	html,
	body {
		width: 100%;
	}
	#app{
		position: relative;
		width: 1600px;
	}
}
#app {
	width: 100vw;
	height: 100vh;
}
.ls-flex-center{
		display: flex;
		align-items: center;
		justify-content: center;
	}
  .ls-flex-center{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.ls-flex-col-center{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

  .fs-14{
		font-size: 0.875rem !important;
		
	}
	.fs-16{
		font-size: 1rem !important;
	}
	.fs-18{
		font-size: 1.125rem !important;
	}
	.fs-20{
		font-size: 1.25rem !important;
	}
	.fs-22{
		font-size: 1.375rem !important;
	}
	.fs-24{
		font-size: 1.5rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 0.875rem !important;
		}
	}
	.fs-28{
		font-size: 1.75rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.125rem !important;
		}
	}
	.fs-26{
		font-size: 1.625rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1rem !important;
		}
	}
	.fs-30{
		font-size: 1.875rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.25rem !important;
		}
	}
	.fs-32{
		font-size: 2rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.375rem !important;
		}
	}
	.fs-34{
		font-size: 2.125rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.5rem !important;
		}
	}
	.fs-36{
		font-size: 2.25rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.625rem !important;
		}
	}
	.fs-38{
		font-size: 2.375rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.75rem !important;
		}
	}
	.fs-40{
		font-size: 2.5rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.875rem !important;
		}
	}
	.fs-42{
		font-size: 2.625rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 2rem !important;
		}
	}
	.fs-46{
		font-size: 2.875rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 2.25rem !important;
		}
	}
	.fs-60{
		font-size: 3.75rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 3.125rem !important;
		}
	}
  .fs-72{
		font-size: 4.5rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 4.5rem !important;
		}
	}
  .max-width{
		width: 1600px;
		@media screen and (max-width: 1600px) {
			padding-left: 30px;
			padding-right: 30px;
		}
	}
  .bg-1{
    background: #7C1822;
  }
  .bg-2{
    background: hsla(354, 68%, 29%, 0.2);
  }
  .color-1{
    color: #7C1822;
  }
  .color-3{
    color: #EE9139;
  }
  .color-6{
    color: #666666;
  }
  .font-bold{
    font-weight: bold;
  }
  .b-g-1{
    border: 1px solid #D9D9D9;
  }
  .b-b-1{
    border: 1px solid #7C1822;
  }
  .b-b-2{
    border: 2px solid #7C1822;
  }
   .b-bottom-1{
    border-bottom: 1px solid #EFEFEF;
  }
   .b-top-1{
    border-top: 1px solid #E2E2E2;
  }

</style>
